define('lib/Podio.Locale',['require','translate','jquery','jquery-ui','moment','moment-timezone','numeral','lib/jquery/jquery.timeentry','lib/Podio.Config'],function(require) {

  var t = require('translate');
  var $ = require('jquery');
  require('jquery-ui');
  var moment = require('moment');
  require('moment-timezone');
  var numeral = require('numeral');
  require('lib/jquery/jquery.timeentry');

  var podioConfig = require('lib/Podio.Config');

  var helpers = {

    getSharedTexts : function _getSharedTexts() {
      return {
        months: [
          t('January #locale'),
          t('February #locale'),
          t('March #locale'),
          t('April #locale'),
          t('May #locale'),
          t('June #locale'),
          t('July #locale'),
          t('August #locale'),
          t('September #locale'),
          t('October #locale'),
          t('November #locale'),
          t('December #locale')
        ],

        monthsShort: [
          t('Jan #locale'),
          t('Feb #locale'),
          t('Mar #locale'),
          t('Apr #locale'),
          t('May #locale'),
          t('Jun #locale'),
          t('Jul #locale'),
          t('Aug #locale'),
          t('Sep #locale'),
          t('Oct #locale'),
          t('Nov #locale'),
          t('Dec #locale')
        ],

        weekdays: [
          t('Sunday #locale'),
          t('Monday #locale'),
          t('Tuesday #locale'),
          t('Wednesday #locale'),
          t('Thursday #locale'),
          t('Friday #locale'),
          t('Saturday #locale')
        ],

        weekdaysShort: [
          t('Sun #locale'),
          t('Mon #locale'),
          t('Tue #locale'),
          t('Wed #locale'),
          t('Thu #locale'),
          t('Fri #locale'),
          t('Sat #locale')
        ],

        weekdaysMin: [
          t('Su #locale'),
          t('Mo #locale'),
          t('Tu #locale'),
          t('We #locale'),
          t('Th #locale'),
          t('Fr #locale'),
          t('Sa #locale')
        ]
      };
    },

    setupNumeral : function _setupNumeral() {
      if (numeral && podioConfig.localeSettings && podioConfig.localeSettings.number) {
        var locale = podioConfig.localeSettings.locale;

        // Setup numeral for current locale
        var numeralSettings = {
          delimiters: {
            thousands: podioConfig.localeSettings.number.format.delimiter,
            decimal: podioConfig.localeSettings.number.format.separator
          },
          currency: {
              symbol: podioConfig.localeSettings.number.currencySymbol
          },

          // Settings below are not used, but included so numeral will keep working
          abbreviations: {
              thousand: 'k',
              million: 'm',
              billion: 'b',
              trillion: 't'
          },
          ordinal: function (number) {
              var b = number % 10;
              return (~~ (number % 100 / 10) === 1) ? 'th' :
                  (b === 1) ? 'st' :
                  (b === 2) ? 'nd' :
                  (b === 3) ? 'rd' : 'th';
          }
        };

        numeral.language(locale, numeralSettings);
        numeral.language(locale);

      }
    },

    setupMoment : function _setupMoment(sharedTexts) {
      if(moment) {

        var localeSettings = {};
        var locale = 'en';

        if(podioConfig.localeSettings) {
          locale = podioConfig.localeSettings.locale;
          if(podioConfig.localeSettings.moment) {
            localeSettings = podioConfig.localeSettings.moment;
          }
        }

        localeSettings.months = sharedTexts.months;
        localeSettings.monthsShort = sharedTexts.monthsShort;
        localeSettings.weekdays = sharedTexts.weekdays;
        localeSettings.weekdaysShort = sharedTexts.weekdaysShort;

        localeSettings.relativeTime = {
          future : t("in %s #locale"),
          past : t("%s ago #locale"),
          s : t("a few seconds #locale"),
          m : t("a minute #locale"),
          mm : t("%d minutes #locale"),
          h : t("an hour #locale"),
          hh : t("%d hours #locale"),
          d : t("a day #locale"),
          dd : t("%d days #locale"),
          M : t("a month #locale"),
          MM : t("%d months #locale"),
          y : t("a year #locale"),
          yy : t("%d years #locale")
        };

        // Add timezone data to moment
        if (podioConfig.momentTimezone && podioConfig.momentTimezone[0]) {
          moment.tz.add(podioConfig.momentTimezone[0]);
        }

        if(podioConfig.momentTimezone && podioConfig.momentTimezone[1]) {
          moment.tz.link(podioConfig.momentTimezone[1]);
        }

        // Set locale strings on moment
        moment.locale(locale, localeSettings);
        moment.locale(locale);

      }
    },

    setupDatePicker : function _setupDatePicker(sharedTexts) {
      var datePickerSettings = {
        closeText: t('Done #locale'),
        prevText: t('Prev #locale'),
        nextText: t('Next #locale'),
        currentText: t('Today #locale'),
        monthNames: sharedTexts.months,
        monthNamesShort: sharedTexts.monthsShort,
        dayNames: sharedTexts.weekdays,
        dayNamesShort: sharedTexts.weekdaysShort,
        dayNamesMin: sharedTexts.weekdaysMin,
        weekHeader: t('Wk #locale'),
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ''
      };

      if (podioConfig.localeSettings) {
        datePickerSettings.dateFormat = podioConfig.localeSettings.datePicker.dateFormat;
        datePickerSettings.firstDay = podioConfig.localeSettings.datePicker.firstDay;
      }

      $.datepicker.setDefaults(datePickerSettings);
    },

    setupTimeEntry : function _setupTimeEntry() {

      var timeEntrySettings = {
        showSeconds: false,
        timeSteps: [1,1,0],
        spinnerImage: false,
        ampmPrefix: ' ',
        ampmNames: ['AM', 'PM'] // If we need it to say something else than AM/PM, put t() around these strings
      };

      if (podioConfig.localeSettings) {
        timeEntrySettings.show24Hours = podioConfig.localeSettings.timeEntry.show24Hours;
      }

      $.timeEntry.setDefaults(timeEntrySettings);
    }
  };

  function init() {
    var sharedTexts = helpers.getSharedTexts();
    helpers.setupMoment(sharedTexts);
    helpers.setupDatePicker(sharedTexts);
    helpers.setupTimeEntry();
    helpers.setupNumeral();
  }

  init();

  return {
    reInit: init,
    getSharedTexts: helpers.getSharedTexts
  };
});

